import { isPlatformBrowser } from '@angular/common';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BaseSiteService } from '@spartacus/core';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class HttpAsmSsoInterceptor implements HttpInterceptor {
  baseSiteId: string;
  platformId = inject(PLATFORM_ID);
  constructor(private baseSiteService: BaseSiteService) {
    this.baseSiteService.getActive().subscribe((res) => (this.baseSiteId = res));
  }

  intercept(request: HttpRequest<any[]>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (isPlatformBrowser(this.platformId)) {
      const asmUserKeySSO = window.localStorage.getItem('asm-user-key');
      if (asmUserKeySSO && request.url.indexOf('authorizationserver/oauth/token') > 1) {
        request = request.clone({
          body: (request.body as unknown as HttpParams)
            .set('UID', asmUserKeySSO)
            .set('grant_type', 'custom')
            .set('client_secret', 'secret')
            .set('baseSite', this.baseSiteId)
        }) as any;
        window.localStorage.removeItem('asm-user-key');
      }
      else if (request.url.includes('/authorizationserver/oauth/revoke')) {
        if (localStorage.getItem('asm_enabled')) {
          request = request.clone({
            body: (request.body as unknown as HttpParams)
              .set('client_secret', 'secret')
          }) as any;
        }
      }
    }
    return next.handle(request);
  }
}
